module.exports = __webpack_public_path__ + "static/media/sea-turtle-ring_720x480.58cd10ad.jpg";